import type { ComponentEditorMetaDataDefinition } from '../types';

const metaData: ComponentEditorMetaDataDefinition = {
  duplicatable: false,
  a11yConfigurable: false,
};

export default metaData;
